


































// Vue
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapActions } from 'vuex';
import { Mixins } from 'vue-mixin-decorator';

// Models
import Bill, { TransactionType, TransactionTypeLiterals } from '@/manager/billing/models/bill.model';
import { Client } from '@/manager/client/client.model';

// Components
import Input, { InputSize } from '@/shared/components/input.component.vue';

// Mixins
import ErrorMixin from '@/shared/mixins/error.mixin.ts';


@Component({
    components: {
        Input,
    },
    computed: {
        ...mapGetters({
            bill: 'getCurrentBill',
        }),
    },
})
export default class ClientPartial extends Mixins<ErrorMixin>(ErrorMixin) {
    @Prop({ default: new Client() }) private client!: any;

    private inputSize = InputSize;
    private bill!: Bill;

    @Watch('client.user.profile.phone')
    private watchPhone(newVal: any, oldVal: any) {
        if (!newVal) {
            (this.client.user as any).profile.phone = '+';
        } else if (newVal.charAt(0) != '+') {
            newVal = '+' + newVal;
            (this.client.user as any).profile.phone = newVal;
        } else {
            (this.client.user as any).profile.phone = newVal;
        }
    }
}
